import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=cd9dc2e8&scoped=true"
import script from "./header-user.vue?vue&type=script&lang=js"
export * from "./header-user.vue?vue&type=script&lang=js"
import style0 from "./header-user.vue?vue&type=style&index=0&id=cd9dc2e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9dc2e8",
  null
  
)

export default component.exports